export default "__VITE_ASSET__5a131015__"